angular.module('bmsApp.merrymaids.houseTemplate', [])
    .config([
        '$stateProvider',
        function config($stateProvider) {

            $stateProvider

                .state('main.merrymaids.houseTemplate.index', {
                    url: '^/merrymaids/housetemplate',
                    views: {
                        'content@main.merrymaids.houseTemplate': {
                            templateUrl: 'ng/merrymaids/houseTemplate/templates/MMHouseTemplateIndex.html',
                            controller: 'MMHouseTemplateIndexCtrl'
                        },
                        'side@main.merrymaids.houseTemplate': {
                            templateUrl: 'ng/merrymaids/houseTemplate/templates/MMHouseTemplateSide.html'
                        },
                    },
                    ncyBreadcrumb: {label: 'House Templates'}
                })

                .state('main.merrymaids.houseTemplate.index.create', {
                    url: '^/merrymaids/housetemplate/create',
                    views: {
                        'content@main.merrymaids.houseTemplate': {
                            templateUrl: 'ng/merrymaids/houseTemplate/templates/MMHouseTemplateSave.html',
                            controller: 'MMHouseTemplateSaveCtrl'
                        },
                        'side@main.merrymaids.houseTemplate': {
                            templateUrl: 'ng/merrymaids/houseTemplate/templates/MMHouseTemplateSide.html'
                        },
                    },
                    ncyBreadcrumb: {label: 'Create'}
                })

                .state('main.merrymaids.houseTemplate.index.edit', {
                    url: '^/merrymaids/housetemplate/edit/{houseTemplateId}',
                    views: {
                        'content@main.merrymaids.houseTemplate': {
                            templateUrl: 'ng/merrymaids/houseTemplate/templates/MMHouseTemplateSave.html',
                            controller: 'MMHouseTemplateSaveCtrl'
                        },
                        'side@main.merrymaids.houseTemplate': {
                            templateUrl: 'ng/merrymaids/houseTemplate/templates/MMHouseTemplateSide.html'
                        },
                    },
                    ncyBreadcrumb: {label: 'Edit'}
                })

                .state('main.merrymaids.houseTemplate.index.view', {
                    url: '^/merrymaids/housetemplate/view/{houseTemplateId}',
                    views: {
                        'content@main.merrymaids.houseTemplate': {
                            templateUrl: 'ng/merrymaids/houseTemplate/templates/MMHouseTemplateView.html',
                            controller: 'MMHouseTemplateViewCtrl'
                        },
                        'side@main.merrymaids.houseTemplate': {
                            templateUrl: 'ng/merrymaids/houseTemplate/templates/MMHouseTemplateSide.html'
                        },
                    },
                    ncyBreadcrumb: {label: 'View'}
                })

                .state('main.merrymaids.houseTemplate', {
                    abstract: true,
                    views: {
                        'main@main': {
                            templateUrl: 'ng/merrymaids/houseTemplate/templates/MMHouseTemplateMain.html'
                        }
                    }
                })
            ;

        }
    ]);